module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-link', {
    class: {
      selected: _vm.selected
    },
    attrs: {
      "to": _vm.to
    }
  }, [_vm._v(_vm._s(_vm.filter.name))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ab6ad492","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/plano/common/CategoryFilter.vue
// module id = 3343
// module chunks = 0